<div class="comment-popup__container ">
    <div class="cancel_icon">
        <a  (click)="onClose()"><i class="fas fa-times"></i></a>
    </div>
    <div class="wrapper-popup">
        <div class="content-area">
            <h2 class="uiHeaderTitle">My Previous Identifications</h2>
            <div class="list">
                <ul>
                    <li *ngFor="let item of identifications">({{item.created_at | date:'medium'}}) {{item?.user?.display_name}}: "{{item?.comment}}"</li>
                   
                </ul>
            </div>
        </div>


    </div>
</div>